import { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from 'utils/@reduxjs/toolkit';
import { createApi } from '@reduxjs/toolkit/query/react';
import { useInjectReducer } from 'utils/redux-injectors';
import { State } from './types';
import { baseQuery, endpoints } from 'utils/api/endpoints';

export const initialState: State = {
  uploadedFile: null,
};

const slice = createSlice({
  name: 'menuManagement',
  initialState,
  reducers: {},
});

export const api = createApi({
  reducerPath: 'menuManagementApi',
  baseQuery,
  endpoints: builder => ({
    addMenus: builder.mutation<any, { body: any; menuType: string }>({
      query: ({ body, menuType }) => ({
        url: endpoints.MENUS + '/add-menus',
        method: 'POST',
        body: { menuItems: body },
        params: { menuType },
      }),
      invalidatesTags: [{ type: 'menus' } as never],
    }),
    getMenus: builder.query<any, any>({
      query: () => ({
        url: endpoints.MENUS + '/get-menus',
        method: 'GET',
      }),
    }),
    getMenuItemsByType: builder.query<any, any>({
      query: type => ({
        url: endpoints.MENUS + '/get-menus/' + type,
        method: 'GET',
      }),
    }),
    getPages: builder.query<any, any>({
      query: params => ({
        url: endpoints.MENUS + '/get-pages',
        method: 'GET',
        params: params,
      }),
    }),
    getBlogs: builder.query<any, any>({
      query: params => ({
        url: endpoints.MENUS + '/get-blogs',
        method: 'GET',
        params: params,
      }),
    }),
  }),
});

export const { actions: MenuManagementAction } = slice;

export const useMenuManagementSlice = () => {
  useInjectReducer({ key: slice.name, reducer: slice.reducer });
  useInjectReducer({ key: api.reducerPath, reducer: api.reducer });
  return {
    useAddMenusMutation: api.useAddMenusMutation,
    useGetMenusQuery: api.useLazyGetMenusQuery,
    useGetMenuItemsByTypeQuery: api.useLazyGetMenuItemsByTypeQuery,
    useGetPagesQuery: api.useLazyGetPagesQuery,
    useGetBlogsQuery: api.useLazyGetBlogsQuery,
    actions: MenuManagementAction,
  };
};
